export type CollectionPayload<T> =
  | T[]
  | {
      data?: T[];
      records?: T[];
      items?: T[];
      users?: T[];
      products?: T[];
      approvals?: T[];
      total?: number;
      totalRecords?: number;
      count?: number;
      pagination?: {
        total?: number;
      };
    };

export interface NormalizedCollectionResult<T> {
  items: T[];
  total: number;
}

export function normalizeCollectionResponse<T>(
  payload: CollectionPayload<T>,
  keys: Array<'data' | 'records' | 'items' | 'users' | 'products' | 'approvals'>
): NormalizedCollectionResult<T> {
  if (Array.isArray(payload)) {
    return {
      items: payload,
      total: payload.length,
    };
  }

  const items =
    keys
      .map((key) => payload[key])
      .find((value): value is T[] => Array.isArray(value)) ?? [];

  const totalValue = payload.total ?? payload.totalRecords ?? payload.count ?? payload.pagination?.total;
  const total = typeof totalValue === 'number' && Number.isFinite(totalValue) ? totalValue : items.length;

  return { items, total };
}

export function toOptionalSearch(search?: string): string | undefined {
  const normalizedSearch = search?.trim();
  console.log(normalizedSearch, 'normalizedSearch');
  return normalizedSearch ? normalizedSearch : undefined;
}
